import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = [ "heroImage", "preloader" ]

  connect() {
    this.loadImages()
  }

  loadImages() {
    this.heroImageTargets.forEach((heroImage, index) => {
      if (heroImage.complete) {
        this.displayImage(index)
      } else {
        heroImage.onload = () => this.displayImage(index)
      }
    })
  }

  displayImage(index) {
    this.preloaderTargets[index].classList.add("hidden")
    this.heroImageTargets[index].classList.remove("hidden")
  }
}

{/* <div id="preloader" class="lds-hourglass hidden" data-hero-image-target="preloader" style="transform: translate(-50%, -50%);"></div> */}